import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@prism/button';
import Dropdown from '@prism/dropdown';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded$3 = ["children", "className", "tag", "size", "readonly"];

var InputGroup = function InputGroup(props) {
  var children = props.children,
      className = props.className,
      Tag = props.tag,
      size = props.size,
      readonly = props.readonly,
      attributes = _objectWithoutProperties(props, _excluded$3);

  var classes = classNames(className, 'input-group', size ? "input-group-".concat(size) : null); // Add readonly prop to children if InputGroup is readonly

  var computedChildren = readonly ? React.Children.map(children, function (child) {
    var newChild = _objectSpread2({}, child);

    newChild.props = _objectSpread2(_objectSpread2({}, newChild.props), {}, {
      readonly: readonly
    });
    return newChild;
  }) : children;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes,
    readOnly: readonly
  }), computedChildren);
};

InputGroup.propTypes = {
  children: PropTypes.node,
  tag: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
  size: PropTypes.string,
  className: PropTypes.string,
  readonly: PropTypes.bool
};
InputGroup.defaultProps = {
  children: null,
  tag: 'div',
  size: 'md',
  className: '',
  readonly: false
};

var _excluded$2 = ["className", "tag"];

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, _excluded$2);

  var classes = classNames(className);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

InputGroupText.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
  className: PropTypes.string
};
InputGroupText.defaultProps = {
  tag: 'span',
  className: 'input-group-text'
};

var _excluded$1 = ["className", "tag", "addonType", "children"];

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = _objectWithoutProperties(props, _excluded$1);

  var classes = classNames(className, "input-group-".concat(addonType)); // Convenience to assist with transition

  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
      className: classes
    }), /*#__PURE__*/React.createElement(InputGroupText, null, children));
  }

  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }), children);
};

InputGroupAddon.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
  addonType: PropTypes.oneOf(['prepend', 'append']).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
InputGroupAddon.defaultProps = {
  tag: 'div',
  children: null,
  className: ''
};

var warned = {};
var warnOnce = function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
};

var _excluded = ["children", "groupClassName", "groupAttributes"],
    _excluded2 = ["tag", "addonType"];

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "Inp' + 'utGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = _objectWithoutProperties(props, _excluded);

  if (typeof children === 'string') {
    var tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = _objectWithoutProperties(propsWithoutGroup, _excluded2);

    var allGroupAttributes = _objectSpread2(_objectSpread2({}, groupAttributes), {}, {
      tag: tag,
      addonType: addonType
    });

    return /*#__PURE__*/React.createElement(InputGroupAddon, _extends({}, allGroupAttributes, {
      className: groupClassName
    }), /*#__PURE__*/React.createElement(Button, attributes, children));
  }

  return /*#__PURE__*/React.createElement(InputGroupAddon, props, children);
};

InputGroupButton.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  addonType: PropTypes.oneOf(['prepend', 'append']).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  groupClassName: PropTypes.string,
  groupAttributes: PropTypes.oneOfType([PropTypes.object]),
  className: PropTypes.string
};
InputGroupButton.defaultProps = {
  tag: 'div',
  children: null,
  groupClassName: '',
  groupAttributes: [],
  className: ''
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return /*#__PURE__*/React.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = {
  addonType: PropTypes.oneOf(['prepend', 'append']).isRequired,
  children: PropTypes.node
};
InputGroupButtonDropdown.defaultProps = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

InputGroup.Addon = InputGroupAddon;
InputGroup.Button = InputGroupButton;
InputGroup.ButtonDropdown = InputGroupButtonDropdown;
InputGroup.Text = InputGroupText;

export { InputGroupAddon, InputGroupButton, InputGroupButtonDropdown, InputGroupText, InputGroup as default };
//# sourceMappingURL=index.js.map
